export async function fetchSuggestions(query) {
    try {
        const url = `${window.BASE_URL}search/ajax/suggest/?q=${query}`;
        const response = await fetch(url, {
            method: 'GET',
            mode: 'cors',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return await response.json();
    } catch (e) {
        console.error(e);
        return [];
    }
}

export async function fetchPosts(query) {
    try {
        const url = `${window.BASE_URL}rest/pl/V1/blog/post-search?q=${query}`;
        const response = await fetch(url, {
            method: 'GET',
            mode: 'cors',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const result = await response.json();

        if (!result.length) return [];

        return result[0].posts;
    } catch (e) {
        console.error(e);
        return [];
    }
}
